import styled from "styled-components/macro";

export const ImgQtc2 = styled.img`
grid-area: qtc;
`;